import { UploadFile } from 'antd/lib/upload/interface';
import * as React from 'react';
import Upload, { RcFile } from 'antd/lib/upload';
import { antGrey } from '@/components/styles/globalStyles';
import Spin from 'antd/lib/spin';
import { LoadingOutlined } from '@ant-design/icons';

interface UploadActionProps {
    file: UploadFile[];
    acceptedFileTypes: string[];
    handleUpload: (file: RcFile) => void;
    isLoading: boolean;
}

function DropFileText() {
    return (
        <div
            style={{
                pointerEvents: 'none',
                fontSize: 20,
                lineHeight: `28px`,
                color: antGrey.grey6,
                fontWeight: 600,
                textAlign: 'center',
            }}
        >
            Drop file here or click to upload
        </div>
    );
}

function LoadingSpinner() {
    return (
        <Spin
            style={{ display: 'flex', width: '100%' }}
            indicator={<LoadingOutlined style={{ fontSize: 40, margin: '0 auto' }} spin />}
        />
    );
}

export const FileUploadDialog = ({ file, acceptedFileTypes, handleUpload, isLoading }: UploadActionProps) => {
    // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept
    const acceptedFileTypesString = acceptedFileTypes.join(',');

    const onUpload = (file) => {
        handleUpload(file);
        // Return false to prevent the file from being uploaded by the Upload component since we have already handled the upload
        return false;
    };

    return (
        <>
            {/*
            antd doesn't directly expose styling of the Upload wrapper within their upload component, so we apply
            the styling with "old-school" css selectors here
            */}
            <style> {`div.ant-upload { width: 100%; }`} </style>
            <Upload beforeUpload={onUpload} fileList={file} accept={acceptedFileTypesString}>
                <div
                    style={{
                        backgroundColor: isLoading ? `${antGrey.grey2}` : `${antGrey.grey1}`,
                        border: `4px dashed`,
                        borderColor: isLoading ? antGrey.grey5 : antGrey.grey4,
                        borderRadius: 8,
                        width: '100%',
                        padding: isLoading ? 20 : 26,
                    }}
                >
                    {isLoading ? LoadingSpinner() : DropFileText()}
                </div>
            </Upload>
        </>
    );
};
